// src/config.js
const AppConfig = {
    title: "test",
    paragraph: "Jj",
    img: "https://i.postimg.cc/6q4xSPKy/Screenshot-2026-01-12-133226.png",
    url: "Gjnd",
    id: "123456"
};

export default AppConfig;